const refs = {
  eventInput: document.querySelector('.search-event-area'),
  eventInputCountry: document.querySelector('#countries-list'),
  body: document.querySelector('body'),
  countryInput: document.querySelector('.search-country-area'),
  gallery: document.querySelector('.gallery'),
  closeMdl: document.querySelector('.modal_button'),
  modalOverlay: document.querySelector('.modal_overlay'),
  modalImg: document.querySelector('.img-card_image'),
  smallModalImg: document.querySelector('.img-card_image_small'),
  modalGallery: document.querySelector('.modal_gallery'),
  pagination: document.querySelector('#tui-pagination-container'),
  modal: document.querySelector('.modal'),
  firstPagBtn: document.querySelector('.tui-first'),
  prevPagBtn: document.querySelector('.tui-prev'),
  btnArrow: document.querySelector('.icon--rotate'),
  countryItem: document.querySelector('.countries-item'),
  containerCountries: document.querySelector('.containner-countries'),
  inputLineBottom: document.querySelector('add-line'),
  form: document.querySelector('.form-container'),
};

export const {
  eventInput,
  eventInputCountry,
  countryInput,
  gallery,
  modalGallery,
  pagination,
  modal,
  modalImg,
  closeMdl,
  modalOverlay,
  body,
  firstPagBtn,
  prevPagBtn,
  btnArrow,
  countryItem,
  containerCountries,
  inputLineBottom,
  dropdown,
  form,
} = refs;
